import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* eslint-disable react/jsx-props-no-spreading */
import { BackdropLoader, toast, Icon, SelectMenu } from '@livable/saas-react-components';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Paper, Button, Alert, MenuItem } from '@mui/material';
// NOTE: disabled check payout LB-1758
// import { RegularCheckPaymentOptionForm } from 'src/components/settings/RegularCheckPaymentOptionForm';
import { ACHPaymentOptionForm } from 'src/components/settings/ACHPaymentOptionForm';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores';
import useStyles from './styles';
import { PAYMENT_METHODS } from 'src/constants/payments';
import HelpCenterButton from 'src/components/shared/HelpCenterButton';
import { useFormik } from 'formik';
import { propertyPayoutDetailsInitVales, propertyPayoutDetailsValidationScheme } from 'src/utils/formValidation/AddNewProperty';
import { PROPERTY_STEPS, APPFOLIO_PROPERTY_STEPS } from 'src/constants/property';
import { PayGateModal } from 'src/components/utilities/PayGateModal';
import { ReimbursementModal } from 'src/pages/NewBillingModule/ReimbursementModal';
export const PropertyPayoutDetailsPage = observer(_ref => {
  var _store$homeDashboardS4, _store$homeDashboardS5, _store$homeDashboardS6;
  let handleStep = _ref.handleStep,
    notCompletedPropertyId = _ref.notCompletedPropertyId,
    editMode = _ref.editMode,
    mutablePropertyId = _ref.mutablePropertyId,
    registerActionBack = _ref.registerActionBack,
    registerActionNext = _ref.registerActionNext;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  let fetchData;
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    card = _useState2[0],
    setCard = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isNewMethodAdded = _useState4[0],
    setIsNewMethodAdded = _useState4[1];
  const _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    prevPaymentMethods = _useState6[0],
    setPrevPaymentMethods = _useState6[1];
  const handleCardChange = event => {
    if (event.target.value) setCard(event.target.value);
  };
  const propertyId = localStorage.getItem('livable_property_id') || notCompletedPropertyId || mutablePropertyId;
  const CURRENT_STEPS = store.company.companyFeatureStore.isAppfolio ? APPFOLIO_PROPERTY_STEPS : PROPERTY_STEPS;
  const goToNextStep = async () => {
    await store.properties.updatePropertySetupProgressAsync.run({
      propertyId: propertyId,
      propertySetupStep: Object.keys(CURRENT_STEPS).find(key => CURRENT_STEPS[key] === CURRENT_STEPS.PayoutDetails)
    });
    if (!mutablePropertyId) {
      if (store.company.companyFeatureStore.isAppfolio) {
        store.addNewProperty.changeCompletedStep(CURRENT_STEPS.ConfirmProperty);
        handleStep(CURRENT_STEPS.ConfirmProperty)();
      } else {
        store.addNewProperty.changeCompletedStep(CURRENT_STEPS.UtilityConfiguration);
        handleStep(CURRENT_STEPS.UtilityConfiguration)();
      }
    }
  };
  const sendPayoutData = async _ref2 => {
    let nameOnAccount = _ref2.nameOnAccount,
      depositoryName = _ref2.depositoryName,
      routingNumber = _ref2.routingNumber,
      accountNumber = _ref2.accountNumber,
      achDepositDataPaymentId = _ref2.achDepositDataPaymentId,
      payeeName = _ref2.payeeName,
      payeeAddress = _ref2.payeeAddress,
      regularCheckPaymentId = _ref2.regularCheckPaymentId,
      paymentMethod = _ref2.paymentMethod;
    try {
      if (false && nameOnAccount && depositoryName && routingNumber && accountNumber) {
        const reqData = {
          propertyId,
          nameOnAccount,
          depositoryName,
          routingNumber,
          accountNumber,
          isPrimary: paymentMethod === PAYMENT_METHODS.ACH,
          id: achDepositDataPaymentId
        };
        if (achDepositDataPaymentId) {
          await store.payment.putPayoutAchDirectDepositAsync.run(reqData);
        } else {
          await store.payment.postPayoutAchDirectDepositAsync.run(reqData);
        }

        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        // !!response?.isSuccessful &&
        //   toast('success', {
        //     body: [
        //       achDepositDataPaymentId
        //         ? t('general.successfully_updated')
        //         : 'Successfully added',
        //     ],
        //   });
      }
      if (false && payeeName && payeeAddress) {
        const reqData = {
          propertyId,
          payeeName,
          payeeAddress,
          isPrimary: paymentMethod === PAYMENT_METHODS.RegularCheck,
          id: regularCheckPaymentId
        };
        // NOTE: disabled check payout LB-1758
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const response = regularCheckPaymentId ? await store.payment.putPayoutRegularCheckAsync.run(reqData) : await store.payment.postPayoutRegularCheckAsync.run(reqData);
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        // !!response?.isSuccessful &&
        // toast('success', {
        //   body: [
        //     achDepositDataPaymentId
        //       ? t('general.successfully_updated')
        //       : 'Successfully added',
        //   ],
        // });
      }
      if (!((store.account.userProfile.isUserAdmin || store.account.userProfile.isUserSuperAdmin) && !card)) {
        await store.payment.setPropertyPaymentMethodAsync.run({
          propertyId: propertyId,
          paymentMethodId: card
        });
      }
      if (editMode && mutablePropertyId) {
        toast('success', {
          body: ['Successfully saved']
        });
        await fetchData();
      } else {
        await goToNextStep();
      }
    } catch (e) {
      console.log('Error', e);
    }
  };
  const formik = useFormik({
    initialValues: propertyPayoutDetailsInitVales,
    validationSchema: propertyPayoutDetailsValidationScheme,
    onSubmit: async values => {
      await sendPayoutData(values);
    }
  });
  fetchData = async () => {
    var _store$homeDashboardS;
    // NOTE: disabled check payout LB-1758
    // const [achDirectDepositResp, regularCheckResp] = await Promise.all([
    await Promise.all([await store.payment.getPayoutAchDirectDepositAsync.run({
      propertyId
    }), await store.payment.getPaymentMethodsV2Async.run({
      applyToHomeDashboard: false
    }), await store.payment.getPropertyPaymentMethodAsync.run({
      applyToHomeDashboard: false,
      propertyId: propertyId
    }),
    // await store.payment.getPayoutRegularCheckAsync.run({
    //   propertyId,
    // }),
    false ? await store.portfolios.getPortfoliosDashboardAsync.run({
      storeCompany: true
    }, [propertyId]) : undefined, store.account.featureFlagsStore.getIsNewPayoutEnabled ? (_store$homeDashboardS = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.fetchCompanyPayoutMethods({
      customInProgressFetchId: propertyId
    }) : undefined]).then(async values => {
      var _values$, _values$2, _values$4, _values$6;
      const defaultPaymentMethod = (_values$ = values[1]) === null || _values$ === void 0 ? void 0 : _values$.response.find(i => i.isDefault);
      if (values[1] && (_values$2 = values[1]) !== null && _values$2 !== void 0 && _values$2.isSuccessful) {
        var _values$3;
        setPrevPaymentMethods((_values$3 = values[1]) === null || _values$3 === void 0 ? void 0 : _values$3.response);
      }
      if ((_values$4 = values[2]) !== null && _values$4 !== void 0 && (_values$4 = _values$4.response) !== null && _values$4 !== void 0 && _values$4.paymentMethodId) {
        var _values$5;
        setCard((_values$5 = values[2]) === null || _values$5 === void 0 || (_values$5 = _values$5.response) === null || _values$5 === void 0 ? void 0 : _values$5.paymentMethodId);
      } else {
        setCard(defaultPaymentMethod === null || defaultPaymentMethod === void 0 ? void 0 : defaultPaymentMethod.id);
      }
      if ((_values$6 = values[0]) !== null && _values$6 !== void 0 && _values$6.isSuccessful) {
        var _values$7, _values$8, _values$9, _values$0, _values$1, _values$10;
        await formik.setFieldValue('achDepositDataPaymentId', (_values$7 = values[0]) === null || _values$7 === void 0 || (_values$7 = _values$7.response) === null || _values$7 === void 0 ? void 0 : _values$7.id);
        await formik.setFieldValue('nameOnAccount', ((_values$8 = values[0]) === null || _values$8 === void 0 || (_values$8 = _values$8.response) === null || _values$8 === void 0 ? void 0 : _values$8.nameOnAccount) || '');
        await formik.setFieldValue('depositoryName', ((_values$9 = values[0]) === null || _values$9 === void 0 || (_values$9 = _values$9.response) === null || _values$9 === void 0 ? void 0 : _values$9.depositoryName) || '');
        await formik.setFieldValue('routingNumber', ((_values$0 = values[0]) === null || _values$0 === void 0 || (_values$0 = _values$0.response) === null || _values$0 === void 0 ? void 0 : _values$0.routingNumber) || '');
        await formik.setFieldValue('accountNumber', ((_values$1 = values[0]) === null || _values$1 === void 0 || (_values$1 = _values$1.response) === null || _values$1 === void 0 ? void 0 : _values$1.accountNumber) || '');
        if ((_values$10 = values[0]) !== null && _values$10 !== void 0 && (_values$10 = _values$10.response) !== null && _values$10 !== void 0 && _values$10.isPrimary) {
          await formik.setFieldValue('paymentMethod', PAYMENT_METHODS.ACH);
        }
      }
    });

    // NOTE: disabled check payout LB-1758
    // if (regularCheckResp?.isSuccessful) {
    //   await formik.setFieldValue(
    //     'regularCheckPaymentId',
    //     regularCheckResp.response?.id
    //   );
    //   await formik.setFieldValue(
    //     'payeeName',
    //     regularCheckResp.response?.payeeName || ''
    //   );
    //   await formik.setFieldValue(
    //     'payeeAddress',
    //     regularCheckResp.response?.payeeAddress || ''
    //   );
    //   if (regularCheckResp.response?.isPrimary) {
    //     await formik.setFieldValue(
    //       'paymentMethod',
    //       PAYMENT_METHODS.RegularCheck
    //     );
    //   }
    // }
  };
  const handlePaymentMethodChange = async value => {
    if (value) {
      await formik.setFieldValue('paymentMethod', value);
    }
  };
  const capitalizeFirstLetter = string => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };
  useEffect(() => {
    fetchData();
    const pageContainerElement = document.getElementById('pageContainer');
    pageContainerElement.scrollTop = 0;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (isNewMethodAdded) {
      store.payment.paymentMethods.map(i => {
        if (prevPaymentMethods.findIndex(si => si.id === i.id) < 0) {
          setCard(i.id);
          setIsNewMethodAdded(false);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isNewMethodAdded]);

  // NOTE: START Reimbursement methods section (aka payouts)
  const _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isReimbursementModalOpen = _useState8[0],
    setReimbursementModalOpen = _useState8[1];
  const handleOpenReimbursementModal = () => setReimbursementModalOpen(true);
  const handleCloseReimbursementModal = () => setReimbursementModalOpen(false);
  const _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isReimbursementSelectOpen = _useState0[0],
    setReimbursementSelectOpen = _useState0[1];
  const _useState1 = useState(''),
    _useState10 = _slicedToArray(_useState1, 2),
    reimbursementMethodSearchKey = _useState10[0],
    setReimbursementMethodSearchKey = _useState10[1];
  const handleOpenReimbursementSelect = () => {
    setReimbursementMethodSearchKey('');
    setReimbursementSelectOpen(true);
  };
  const handleCloseReimbursementSelect = () => {
    setReimbursementMethodSearchKey('');
    setReimbursementSelectOpen(false);
  };
  const getReimbursementMethodsList = () => {
    var _store$homeDashboardS2, _store$homeDashboardS3;
    const resultList = ((_store$homeDashboardS2 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS2 === void 0 ? void 0 : _store$homeDashboardS2.companyReimbursementMethods) !== null && ((_store$homeDashboardS3 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS3 === void 0 || (_store$homeDashboardS3 = _store$homeDashboardS3.companyReimbursementMethods) === null || _store$homeDashboardS3 === void 0 || (_store$homeDashboardS3 = _store$homeDashboardS3.filter(i => !i.propertyIds.includes(propertyId))) === null || _store$homeDashboardS3 === void 0 ? void 0 : _store$homeDashboardS3.filter(i => {
      const searchPhrase = new RegExp(reimbursementMethodSearchKey, 'gi');
      return reimbursementMethodSearchKey.length > 0 ? " ".concat(i.nameOnAccount).search(searchPhrase) > 0 || " ".concat(i.depositoryName).search(searchPhrase) > 0 || " ".concat(i.routingNumber).search(searchPhrase) > 0 || " ".concat(i.accountNumber).search(searchPhrase) > 0 : true;
    }));
    if ((resultList === null || resultList === void 0 ? void 0 : resultList.length) > 0) {
      return resultList === null || resultList === void 0 ? void 0 : resultList.map(method => {
        if ((method === null || method === void 0 ? void 0 : method.methodType) === PAYMENT_METHODS.ACH) {
          return /*#__PURE__*/React.createElement(MenuItem, {
            value: method.id,
            className: classes.selectPayoutMethodItem
          }, /*#__PURE__*/React.createElement("span", null, "".concat(method.nameOnAccount, " ").concat(method !== null && method !== void 0 && method.depositoryName ? "(".concat(method.depositoryName, ")") : '')), /*#__PURE__*/React.createElement("i", null, "Routing: ".concat(method === null || method === void 0 ? void 0 : method.routingNumber, " ; Account: ").concat(method.accountNumber, ";")));
        }
      });
    } else {
      return /*#__PURE__*/React.createElement(MenuItem, {
        value: 'no_results',
        className: "".concat(classes.selectPayoutMethodItem, " disabled"),
        onClick: event => {
          event.preventDefault();
          event.stopPropagation();
        }
      }, /*#__PURE__*/React.createElement("span", null, t('general.no_matches_found')));
    }
  };
  useEffect(() => {
    if (registerActionBack !== undefined) registerActionBack(() => {
      handleStep(CURRENT_STEPS.FeeSetup)();
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [registerActionBack]);
  useEffect(() => {
    if (registerActionNext !== undefined) registerActionNext(() => {
      formik.handleSubmit();
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [registerActionNext]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, store.account.featureFlagsStore.getIsAppfolioTestEnabled && /*#__PURE__*/React.createElement(Paper, {
    variant: "evenWrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.unitPrice
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.unitPriceTitle
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, t('Unit price')), /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, "You've reached a total number of 25 units and opened the ", /*#__PURE__*/React.createElement("b", null, "Tier 2"), " of unit volume discount so now the monthly price for the unit across all of your properties is ", /*#__PURE__*/React.createElement("b", null, "$6.00"), " per unit instead of $8.00."))), /*#__PURE__*/React.createElement("div", {
    className: classes.unitPriceData
  }, /*#__PURE__*/React.createElement("b", null, "$6.00"), /*#__PURE__*/React.createElement("s", null, "$8.00")))), /*#__PURE__*/React.createElement(Paper, {
    variant: "evenWrapper",
    className: classes.paymentBlock
  }, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: store.payment.getPayoutAchDirectDepositAsync.inProgress || store.payment.postPayoutAchDirectDepositAsync.inProgress || store.payment.putPayoutAchDirectDepositAsync.inProgress || store.payment.getPayoutRegularCheckAsync.inProgress || store.payment.putPayoutRegularCheckAsync.inProgress || store.payment.postPayoutRegularCheckAsync.inProgress || store.payment.getPaymentMethodsAsync.inProgress || store.payment.getPaymentMethodsV2Async.inProgress || store.payment.getPropertyPaymentMethodAsync.inProgress || store.payment.getPublicKeyAsync.inProgress || store.properties.updatePropertySetupProgressAsync.inProgress || store.payment.setPropertyPaymentMethodAsync.inProgress || store.payment.getSetupIntentWithSubscriptionAsync.inProgress
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, t('subscriptions.payment_information')), /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('Please select the payment method you want to use by default.'))), /*#__PURE__*/React.createElement("div", {
    className: classes.lgSection
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    id: "age-selector",
    value: card,
    labelId: "age-selector-label",
    onChange: handleCardChange
  }, store.payment.paymentMethods.map(method => {
    if (method.isDefault) {
      return /*#__PURE__*/React.createElement(MenuItem, {
        value: method.id,
        key: method.id
      }, capitalizeFirstLetter(method.brand), " ending in \u2022\u2022\u2022\u2022 ", method.last4);
    }
  }), store.payment.paymentMethods.map(method => {
    if (!method.isDefault) {
      return /*#__PURE__*/React.createElement(MenuItem, {
        value: method.id,
        key: method.id
      }, capitalizeFirstLetter(method.brand), " ending in \u2022\u2022\u2022\u2022 ", method.last4);
    }
  }))), store.account.userProfile.isUserHasAccessToThePayment && /*#__PURE__*/React.createElement("div", {
    className: classes.lgSection
  }, /*#__PURE__*/React.createElement(PayGateModal, {
    trigger: true,
    newMethodAdded: setIsNewMethodAdded
  }))), /*#__PURE__*/React.createElement("form", {
    id: editMode ? 'edit_property_payout_details' : 'add_property_payout_details',
    onSubmit: formik.handleSubmit
  }, !store.company.companyFeatureStore.disableSendReminder && /*#__PURE__*/React.createElement(Paper, {
    variant: "evenWrapper"
  }, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: store.payment.getPayoutAchDirectDepositAsync.inProgress || store.payment.postPayoutAchDirectDepositAsync.inProgress || store.payment.putPayoutAchDirectDepositAsync.inProgress || store.payment.getPayoutRegularCheckAsync.inProgress || store.payment.putPayoutRegularCheckAsync.inProgress || store.payment.postPayoutRegularCheckAsync.inProgress || store.payment.getPaymentMethodsAsync.inProgress || store.payment.getPaymentMethodsV2Async.inProgress || store.payment.getPropertyPaymentMethodAsync.inProgress || store.payment.getPublicKeyAsync.inProgress || store.properties.updatePropertySetupProgressAsync.inProgress || store.payment.setPropertyPaymentMethodAsync.inProgress || store.payment.getSetupIntentWithSubscriptionAsync.inProgress
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h3"
  }, t('add_new_property_flow.reimbursement_details')), store.account.featureFlagsStore.getIsNewPayoutEnabled ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('Please select the reimbursement method you want to use by default. (Optional)'))), /*#__PURE__*/React.createElement("div", {
    className: classes.lgSection
  }, !((_store$homeDashboardS4 = store.homeDashboardStore.getCurrentCompany) !== null && _store$homeDashboardS4 !== void 0 && (_store$homeDashboardS4 = _store$homeDashboardS4.companyReimbursementMethods) !== null && _store$homeDashboardS4 !== void 0 && _store$homeDashboardS4.length) ? /*#__PURE__*/React.createElement(Button, {
    variant: "actionButtonInvert",
    disabled: store.payment.assignCompanyPayoutMethodToPropertyAsync.inProgress,
    onClick: () => {
      handleCloseReimbursementSelect();
      handleOpenReimbursementModal();
    },
    'custom-attribute': '581-new-billing-module'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "plus"
  }), "Add new reimbursement information") : /*#__PURE__*/React.createElement(SelectMenu, {
    id: "reimbursement-method-selector",
    value: (_store$homeDashboardS5 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS5 === void 0 ? void 0 : _store$homeDashboardS5.getPropertyReimbursementMethods(propertyId),
    disabled: store.payment.assignCompanyPayoutMethodToPropertyAsync.inProgress,
    onChange: event => {
      event.preventDefault();
      event.stopPropagation();
      if (event.target.value === 'no_results') return;
      store.payment.assignCompanyPayoutMethodToPropertyAsync.run({
        payoutMethodId: event.target.value,
        propertyId: propertyId
      }, [propertyId]).then(resp => {
        if (resp.isSuccessful) {
          toast('success', {
            body: ['Successfully updated reimbursement method!']
          });
          store.homeDashboardStore.getCurrentCompany.fetchCompanyPayoutMethods({
            customInProgressFetchId: propertyId
          });
        }
      });
    },
    enableAddAction: false,
    enableSearch: true,
    onSearch: key => setReimbursementMethodSearchKey(key),
    handleClose: handleCloseReimbursementSelect,
    handleOpen: handleOpenReimbursementSelect,
    isOpen: isReimbursementSelectOpen
    // addActionButton={
    //   <Button
    //     variant="menuAction"
    //     onClick={() => {
    //       handleCloseReimbursementSelect();
    //       handleOpenReimbursementModal();
    //     }}
    //     {...{ 'custom-attribute': '870-add-new-property' }}
    //   >
    //     <Icon type="plus-circle" />
    //     Add new reimbursement information
    //   </Button>
    // }
    ,
    renderValue: () => {
      const currentReimbursementMethod = store.homeDashboardStore.getCurrentCompany.getPropertyReimbursementMethods(propertyId);
      if (currentReimbursementMethod === null) {
        return '';
      } else {
        if (currentReimbursementMethod.methodType === PAYMENT_METHODS.ACH) {
          return "".concat(currentReimbursementMethod === null || currentReimbursementMethod === void 0 ? void 0 : currentReimbursementMethod.nameOnAccount, " ").concat(currentReimbursementMethod !== null && currentReimbursementMethod !== void 0 && currentReimbursementMethod.depositoryName ? "(".concat(currentReimbursementMethod.depositoryName, ")") : '');
        } else if (currentReimbursementMethod.methodType === PAYMENT_METHODS.RegularCheck) {
          return 'Check';
        }
      }
    }
  }, getReimbursementMethodsList())), !!((_store$homeDashboardS6 = store.homeDashboardStore.getCurrentCompany) !== null && _store$homeDashboardS6 !== void 0 && (_store$homeDashboardS6 = _store$homeDashboardS6.companyReimbursementMethods) !== null && _store$homeDashboardS6 !== void 0 && _store$homeDashboardS6.length) && /*#__PURE__*/React.createElement("div", {
    className: classes.lgSection
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionButtonInvert",
    onClick: () => {
      handleCloseReimbursementSelect();
      handleOpenReimbursementModal();
    },
    'custom-attribute': '871-add-new-property'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "plus"
  }), "Add new reimbursement information"))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.lgSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('add_new_property_flow.what_is_reimbursement'))), /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('add_new_property_flow.reimbursement_hint'))), /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement(HelpCenterButton, null)), /*#__PURE__*/React.createElement("div", {
    className: classes.lgSection
  }, /*#__PURE__*/React.createElement(ACHPaymentOptionForm, {
    formik: formik,
    handlePrimaryPaymentMethodChange: handlePaymentMethodChange
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.lgSection
  }, /*#__PURE__*/React.createElement(Alert, {
    severity: "info",
    icon: false,
    size: "small"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('add_new_property_flow.authorization_details')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('add_new_property_flow.authorization_text')))))), !editMode && registerActionBack === undefined && registerActionNext === undefined && /*#__PURE__*/React.createElement("div", {
    className: classes.pageFooter
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: handleStep(CURRENT_STEPS.FeeSetup),
    disabled: store.payment.getPayoutAchDirectDepositAsync.inProgress || store.payment.postPayoutAchDirectDepositAsync.inProgress || store.payment.putPayoutAchDirectDepositAsync.inProgress || store.payment.getPayoutRegularCheckAsync.inProgress || store.payment.putPayoutRegularCheckAsync.inProgress || store.payment.postPayoutRegularCheckAsync.inProgress || store.payment.getPaymentMethodsAsync.inProgress || store.payment.getPaymentMethodsV2Async.inProgress || store.payment.getPropertyPaymentMethodAsync.inProgress || store.payment.getPublicKeyAsync.inProgress || store.properties.updatePropertySetupProgressAsync.inProgress || store.payment.setPropertyPaymentMethodAsync.inProgress || store.payment.getSetupIntentWithSubscriptionAsync.inProgress || store.payment.assignCompanyPayoutMethodToPropertyAsync.inProgress,
    'custom-attribute': '112-property-payout-details-page'
  }, t('general.back'), !store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement(React.Fragment, null, ': ', t('add_new_property_flow.fee_structure'))), /*#__PURE__*/React.createElement(Button, {
    variant: "priority",
    form: "add_property_payout_details",
    id: "add_property_payout_details_submit_btn",
    type: "submit",
    disabled: store.payment.getPayoutAchDirectDepositAsync.inProgress || store.payment.postPayoutAchDirectDepositAsync.inProgress || store.payment.putPayoutAchDirectDepositAsync.inProgress || store.payment.getPayoutRegularCheckAsync.inProgress || store.payment.putPayoutRegularCheckAsync.inProgress || store.payment.postPayoutRegularCheckAsync.inProgress || store.payment.getPaymentMethodsAsync.inProgress || store.payment.getPaymentMethodsV2Async.inProgress || store.payment.getPropertyPaymentMethodAsync.inProgress || store.payment.getPublicKeyAsync.inProgress || store.properties.updatePropertySetupProgressAsync.inProgress || store.payment.setPropertyPaymentMethodAsync.inProgress || store.payment.getSetupIntentWithSubscriptionAsync.inProgress || store.payment.assignCompanyPayoutMethodToPropertyAsync.inProgress || !store.account.userProfile.isUserAdmin && !store.account.userProfile.isUserSuperAdmin && store.company.companyFeatureStore.isAppfolio && !card,
    'custom-attribute': '113-property-payout-details-page'
  }, store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement(React.Fragment, null, t('buttons.confirm'), ". ", t('general.next')), !store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement(React.Fragment, null, t('general.next'), ": ", t('add_new_property_flow.utilities_setup')))), editMode && /*#__PURE__*/React.createElement(Button, {
    variant: "priority",
    form: "edit_property_payout_details",
    id: "edit_property_payout_details_submit_btn",
    type: "submit",
    disabled: store.payment.getPayoutAchDirectDepositAsync.inProgress || store.payment.postPayoutAchDirectDepositAsync.inProgress || store.payment.putPayoutAchDirectDepositAsync.inProgress || store.payment.getPayoutRegularCheckAsync.inProgress || store.payment.putPayoutRegularCheckAsync.inProgress || store.payment.postPayoutRegularCheckAsync.inProgress || store.payment.getPaymentMethodsAsync.inProgress || store.payment.getPaymentMethodsV2Async.inProgress || store.payment.getPropertyPaymentMethodAsync.inProgress || store.payment.getPublicKeyAsync.inProgress || store.properties.updatePropertySetupProgressAsync.inProgress || store.payment.setPropertyPaymentMethodAsync.inProgress || store.payment.getSetupIntentWithSubscriptionAsync.inProgress || store.payment.assignCompanyPayoutMethodToPropertyAsync.inProgress,
    'custom-attribute': '114-property-payout-details-page'
  }, t('buttons.save'))), /*#__PURE__*/React.createElement(ReimbursementModal, {
    isOpen: isReimbursementModalOpen,
    handleClose: handleCloseReimbursementModal,
    propertyIdExternal: propertyId,
    triggerRefresh: propertyIdParam => {
      // store.homeDashboardStore.getCurrentCompany.fetchCompanyACHs({ customInProgressFetchId: propertyIdParam });
      // store.homeDashboardStore.getCurrentCompany.fetchCompanyRegularChecks({ customInProgressFetchId: propertyIdParam });
      store.homeDashboardStore.getCurrentCompany.fetchCompanyPayoutMethods({
        customInProgressFetchId: propertyIdParam
      });
    }
  }));
});